export default __webpack_public_path__ + "static/media/190629_192557_DSCN3481.bea277b0.JPG";